import vue from 'vue';

export default function buildMailStore(store){
    store.actions.saveAndSendBatch = async (context, params) => await vue.prototype.$myHttp.post('/api/mails/saveAndSendBatch', params);
    store.actions.getAccounts = async () => await vue.prototype.$myHttp.post('/api/mails/getAccounts');
    return store;
}